"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEVICE_TYPE_MAP = exports.DEVICE_NAME_MAP = exports.UserDeviceType = exports.UnitBaseType = exports.Source = exports.InstantTestType = exports.TestStatus = exports.UnitErrors = exports.IngestingKeys = exports.UnitTestSchedulesTasks = exports.DeviceAvailableTests = exports.UnitAvailableTests = exports.CLOUDFLARE_SK_CDN = void 0;
/**
 * Default CDN location for CloudFlare speed tests.
 */
exports.CLOUDFLARE_SK_CDN = 'samknows-cdn.com';
/**
 * Tests available to run on the unit.
 * General grouping of tests, as the device will choose whether to run e.g. HTTP or UDP tests.
 */
var UnitAvailableTests;
(function (UnitAvailableTests) {
    UnitAvailableTests["DOWNLOAD"] = "unit_download";
    UnitAvailableTests["UPLOAD"] = "unit_upload";
    UnitAvailableTests["JITTER"] = "unit_jitter";
})(UnitAvailableTests = exports.UnitAvailableTests || (exports.UnitAvailableTests = {}));
/**
 * Tests available to run in the browser (on the device).
 * General grouping as the capabilities (e.g. Fetch vs Websocket) are determined by the test.
 */
// Test name and task name are the same for web SDK tests
var DeviceAvailableTests;
(function (DeviceAvailableTests) {
    DeviceAvailableTests["DOWNLOAD"] = "download";
    DeviceAvailableTests["UPLOAD"] = "upload";
    DeviceAvailableTests["LATENCY"] = "latency";
})(DeviceAvailableTests = exports.DeviceAvailableTests || (exports.DeviceAvailableTests = {}));
/**
 * All possible types of task the unit can have schedules for.
 */
var UnitTestSchedulesTasks;
(function (UnitTestSchedulesTasks) {
    UnitTestSchedulesTasks["HTTP_DOWNLOAD_ST"] = "http_get_st";
    UnitTestSchedulesTasks["HTTP_UPLOAD_ST"] = "http_post_st";
    UnitTestSchedulesTasks["HTTP_DOWNLOAD_MT"] = "http_get_mt";
    UnitTestSchedulesTasks["HTTP_UPLOAD_MT"] = "http_post_mt";
    UnitTestSchedulesTasks["UDP_JITTER"] = "udp_jitter";
    UnitTestSchedulesTasks["UDP_DOWNLOAD"] = "udp_accelerated_dl";
    UnitTestSchedulesTasks["UDP_UPLOAD"] = "udp_accelerated_ul";
})(UnitTestSchedulesTasks = exports.UnitTestSchedulesTasks || (exports.UnitTestSchedulesTasks = {}));
/**
 * List of all names of tasks that the ingestion endpoint can be notified about.
 * This is has a 1-1 mapping with the {@see UnitTestSchedulesTasks} and {@see DeviceAvailableTests}.
 */
var IngestingKeys;
(function (IngestingKeys) {
    IngestingKeys["UNIT_HTTP_DOWNLOAD"] = "unit_download";
    IngestingKeys["UNIT_HTTP_UPLOAD"] = "unit_upload";
    IngestingKeys["UNIT_UDP_JITTER"] = "unit_jitter";
    IngestingKeys["UNIT_UDP_DOWNLOAD"] = "unit_udp_download";
    IngestingKeys["UNIT_UDP_UPLOAD"] = "unit_udp_upload";
    IngestingKeys["DEVICE_WEB_DOWNLOAD"] = "download";
    IngestingKeys["DEVICE_WEB_UPLOAD"] = "upload";
    IngestingKeys["DEVICE_WEB_LATENCY"] = "latency";
})(IngestingKeys = exports.IngestingKeys || (exports.IngestingKeys = {}));
/**
 * Types of errors which can be returned by a Unit.
 */
var UnitErrors;
(function (UnitErrors) {
    UnitErrors["UNIT_NOT_FOUND"] = "UNIT_NOT_FOUND";
    UnitErrors["NOT_READY"] = "NOT_READY";
    UnitErrors["UNKNOWN"] = "UNKNOWN";
    UnitErrors["ACCESS_DENIED"] = "ACCESS_DENIED";
    UnitErrors["INTERNAL"] = "INTERNAL";
    UnitErrors["UNIT_BASE_NOT_TRIGGERABLE"] = "UNIT_BASE_NOT_TRIGGERABLE";
    UnitErrors["UNIT_DOES_NOT_EXIST"] = "UNIT_DOES_NOT_EXIST";
    UnitErrors["INVALID_MAC"] = "INVALID_MAC";
    UnitErrors["PANEL_NOT_LMAP_CONTROLLED"] = "PANEL_NOT_LMAP_CONTROLLED";
    UnitErrors["UNRECOGNISED_UNIT"] = "UNRECOGNISED_UNIT";
    UnitErrors["NON_COMPATIBLE_PANEL"] = "NON_COMPATIBLE_PANEL";
    UnitErrors["IN_PROGRESS"] = "IN_PROGRESS";
    UnitErrors["UNREACHABLE"] = "UNREACHABLE";
    UnitErrors["NO_AVAILABLE_TESTS"] = "NO_AVAILABLE_TESTS";
    UnitErrors["TARGET_AT_CAPACITY"] = "TARGET_AT_CAPACITY";
    UnitErrors["AGENT_TIMED_OUT"] = "AGENT_TIMED_OUT";
})(UnitErrors = exports.UnitErrors || (exports.UnitErrors = {}));
var TestStatus;
(function (TestStatus) {
    TestStatus["ACKNOWLEDGE"] = "acknowledge";
    TestStatus["STARTING"] = "starting";
    TestStatus["IN_PROGRESS"] = "in_progress";
    TestStatus["FINISHED"] = "finished";
    TestStatus["QUEUED"] = "queued";
    TestStatus["REQUESTING"] = "requesting";
})(TestStatus = exports.TestStatus || (exports.TestStatus = {}));
/**
 * Distinguishes between Unit tests (agent) and Device tests (in-browser).
 */
var InstantTestType;
(function (InstantTestType) {
    InstantTestType["UNIT_TEST"] = "UNIT_TEST";
    InstantTestType["DEVICE_TEST"] = "DEVICE_TEST";
})(InstantTestType = exports.InstantTestType || (exports.InstantTestType = {}));
var Source;
(function (Source) {
    Source["REAL_SPEED_APP"] = "real_speed,web_app";
    Source["REAL_SPEED_IFRAME"] = "real_speed,web_iframe";
    Source["INSTANT_TEST"] = "instant_test";
})(Source = exports.Source || (exports.Source = {}));
var UnitBaseType;
(function (UnitBaseType) {
    UnitBaseType["WHITE_BOX_8"] = "skwb8";
    UnitBaseType["WHITE_BOX_8_PLUS"] = "skwb8p";
    UnitBaseType["ARRIS_MERCURY"] = "arris-mercury";
    UnitBaseType["ARRIS_MERCURY_2"] = "arris-mercury-v2";
    UnitBaseType["LGONE_MV2PLUS"] = "lgone-mv2p";
    UnitBaseType["LGONE_MV3"] = "lgone-mv3";
})(UnitBaseType = exports.UnitBaseType || (exports.UnitBaseType = {}));
var UserDeviceType;
(function (UserDeviceType) {
    UserDeviceType["PHONE"] = "smartphone";
    UserDeviceType["TABLET"] = "tablet";
    UserDeviceType["COMPUTER"] = "desktop";
    UserDeviceType["CONSOLE"] = "console";
})(UserDeviceType = exports.UserDeviceType || (exports.UserDeviceType = {}));
exports.DEVICE_NAME_MAP = {
    [UserDeviceType.PHONE]: 'phone',
    [UserDeviceType.TABLET]: 'tablet',
    [UserDeviceType.COMPUTER]: 'computer',
    [UserDeviceType.CONSOLE]: 'console'
};
exports.DEVICE_TYPE_MAP = {
    mobile: UserDeviceType.PHONE,
    tablet: UserDeviceType.TABLET,
    desktop: UserDeviceType.COMPUTER,
    console: UserDeviceType.CONSOLE
};
//# sourceMappingURL=InstantTest.const.js.map